"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const routes_1 = require("@authlance/core/lib/common/routes/routes");
const index_1 = require("./pages/IndexPage/index");
const Docs_1 = require("./pages/Docs");
const home_content_contribution_1 = require("./contributions/home-content-contribution");
const ui_contributions_1 = require("@authlance/core/lib/browser/common/ui-contributions");
const terms_registration_footer_contribution_1 = require("./contributions/terms-registration-footer-contribution");
const contributions_1 = require("@authlance/identity/lib/browser/common/contributions");
const sitemap_contribution_1 = require("./contributions/sitemap-contribution");
exports.default = new inversify_1.ContainerModule((bind) => {
    bind(home_content_contribution_1.HomeContentContribution).toSelf();
    bind(ui_contributions_1.DefaultDashboardContentContributor).toService(home_content_contribution_1.HomeContentContribution);
    bind(index_1.HomePageContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(index_1.HomePageContribution);
    bind(Docs_1.DocsGettingStartedPageContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsGettingStartedPageContribution);
    bind(Docs_1.DocsAuthContainerOverviewContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsAuthContainerOverviewContribution);
    bind(Docs_1.DocsAuthContainerConfigurationContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsAuthContainerConfigurationContribution);
    bind(Docs_1.DocsAuthContainerCommandsContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsAuthContainerCommandsContribution);
    bind(Docs_1.DocsAuthContainerNatsEventsContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsAuthContainerNatsEventsContribution);
    bind(Docs_1.DocsLicenseOperatorOverviewContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsLicenseOperatorOverviewContribution);
    bind(Docs_1.DocsLicenseOperatorConfigurationContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsLicenseOperatorConfigurationContribution);
    bind(Docs_1.DocsLicenseOperatorNatsEventsContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsLicenseOperatorNatsEventsContribution);
    bind(Docs_1.DocsFrameworkGuideContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsFrameworkGuideContribution);
    bind(Docs_1.DocsFrameworkRoutingContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsFrameworkRoutingContribution);
    bind(Docs_1.DocsFrameworkContributionsContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsFrameworkContributionsContribution);
    bind(Docs_1.DocsFrameworkOperationsContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsFrameworkOperationsContribution);
    bind(Docs_1.DocsDeploymentDevelopmentEnvironmentContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsDeploymentDevelopmentEnvironmentContribution);
    bind(Docs_1.DocsDeploymentDockerContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsDeploymentDockerContribution);
    bind(Docs_1.DocsDeploymentHelmContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsDeploymentHelmContribution);
    bind(Docs_1.DocsAuthContainerOpenApiContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsAuthContainerOpenApiContribution);
    bind(Docs_1.DocsLicenseOperatorOpenApiContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.DocsLicenseOperatorOpenApiContribution);
    bind(Docs_1.TermsOfServiceContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(Docs_1.TermsOfServiceContribution);
    bind(terms_registration_footer_contribution_1.TermsRegistrationFooterContribution).toSelf();
    bind(contributions_1.RegistrationFooterContribution).toService(terms_registration_footer_contribution_1.TermsRegistrationFooterContribution);
    bind(sitemap_contribution_1.SitemapContribution).toSelf();
    bind(routes_1.RoutesApplicationContribution).toService(sitemap_contribution_1.SitemapContribution);
});
